import { render, staticRenderFns } from "./ChallengeManagementHelp.vue?vue&type=template&id=9fd5708a&scoped=true"
import script from "./ChallengeManagementHelp.vue?vue&type=script&lang=js"
export * from "./ChallengeManagementHelp.vue?vue&type=script&lang=js"
import style0 from "./ChallengeManagementHelp.vue?vue&type=style&index=0&id=9fd5708a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd5708a",
  null
  
)

export default component.exports